import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Inquiry',
  baseUrl: '/admin/seller/quote',
  routes: [
    {
      path: '/',
      page: 'InquiryPage',
      title: 'Inquiry Page',
      exact: true
    },
    {
      path: '/:productId',
      page: 'InquiryDetailPage',
      title: 'Inquiry Detail Page',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
